var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-row", { staticClass: "empty-container" }, [
    _c("span", { staticClass: "iconfont icon-empty" }),
    _c("span", { staticClass: "empty-text" }, [_vm._v("暂无数据")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }